let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eQ37H")).then(() => parcelRequire('4A5oU'));